import Lottie from 'lottie-web';

export default class OurTechnology {
  init() {
    this._initLottieAnimation();
  }

  _initLottieAnimation() {
    let containerElemShield = document.body.querySelector('.illiustration-animation-wrapper-shield');
    let containerElemCube = document.body.querySelector('.illiustration-animation-wrapper-cube');
    let containerElemHexagon = document.body.querySelector('.illiustration-animation-wrapper-hexagon');

    Lottie.loadAnimation({
        container: containerElemHexagon, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: './images/arweave-animation-hexagon.data.json' // the path to the animation json
      });

    Lottie.loadAnimation({
      container: containerElemShield, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: './images/arweave-animation-shield.data.json' // the path to the animation json
    });

    Lottie.loadAnimation({
        container: containerElemCube, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: './images/arweave-animation-cube.data.json' // the path to the animation json
      });

  }
}
